// extracted by mini-css-extract-plugin
module.exports = {"streamTitle":"StreamInfo_streamTitle__3zb3s","streamDescription":"StreamInfo_streamDescription__JSaP8"};